import React, { useCallback } from 'react';
import { useAtom } from 'jotai';
import { Box, Snackbar } from '@mui/material';

import { toastAtom } from '../../atoms';
import styles from './style';

// A success goes quickly; a warning or an error stays longer, to be read.
const SUCCESS_DURATION = 2500;
const ALERT_DURATION = 6000;

const ICONS = {
  success: '✓',
  warning: '!',
  error: '✕',
};

// Short message at the top right, opened from anywhere with toastAtom (like the toasts of the app).
const Toast: React.FC = React.memo(() => {
  const [toast, setToast] = useAtom(toastAtom);
  const severity = (toast && toast.severity) || 'success';

  const close = useCallback((event?: React.SyntheticEvent | Event, reason?: string) => {
    // A click elsewhere on the page doesn't close it before its time.
    if (reason !== 'clickaway') {
      setToast(null);
    }
  }, [setToast]);

  return (
    <Snackbar
      key={toast ? toast.id : 0}
      open={!!toast}
      autoHideDuration={severity === 'success' ? SUCCESS_DURATION : ALERT_DURATION}
      onClose={close}
      anchorOrigin={styles.anchorOrigin}
      sx={styles.snackbar}
    >
      <Box role={severity === 'success' ? 'status' : 'alert'} sx={[styles.toast, styles.accents[severity]]}>
        <Box component="span" sx={[styles.icon, styles.icons[severity]]}>{ICONS[severity]}</Box>
        {toast ? toast.text : ''}
      </Box>
    </Snackbar>
  );
});

export default Toast;
